// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__R-wEE","subheader":"ReorderModal_subheader__3_WIm","listWrap":"ReorderModal_listWrap__gYdfx"};